export default {
    props: {
        msgBox: {
            type: Object,
            required: false,
            default: null
            // msgBox = {
            // title: 'Zmiana rodzaju wnioskowanego wsparcia',
            // content: 'Czy chcesz zmienić rodzaj wnioskowanego wsparcia? Akceptacja będzie skutkowała usunięciem dotychczas wprowadzonych danych dotyczących obecnego wsparcia.',
            // buttons: [
            //   {
            //     type: 'doit',
            //     value: 'Tak - zmieniam rodzaj wnioskowanego wsparcia'
            //   },
            //   {
            //     type: 'dont',
            //     value: 'Nie - anuluję zmianę rodzaju wnioskowanego wsparcia'
            //   }
            // ],
            // callback: this.setSections
            // }
        }
    },
    methods: {
        smartMessageBox(evt, msgBox) {
            const options = {
                title: msgBox.title,
                content: msgBox.content,
                buttons: msgBox.buttons.map(x => "[" + x.value + "]").join('')
            };
            if (this.formParent.$listeners && this.formParent.$listeners['smart-message-box'])
                this.formParent.$emit('smart-message-box', evt, options, msgBox.callback);
            else {
                let msg;
                if (confirm(options.title)) {
                    msg = msgBox.buttons.find(x => x.type === "doit").value;
                }
                else {
                    msg = msgBox.buttons.find(x => x.type === "dont").value;
                    if (!msg) {
                        msg = msgBox.buttons.find(x => x.type !== "doit").value;
                    }
                }

                console.log(msgBox);
                return msgBox.callback(msg);
            }
        }
    },
    computed: {
        formParent: {
            get() {
                let parent = this.$parent;
                for (; ;) {
                    if (parent.form) {
                        break;
                    }

                    if (parent.$parent) {
                        parent = parent.$parent;
                    }

                    if (!parent.$parent) {
                        parent = undefined;
                        break;
                    }
                }
                return parent;
            }
        }
    }
}